import { render, staticRenderFns } from "./EditGroupDrawer.vue?vue&type=template&id=36ff67d8&scoped=true"
import script from "./EditGroupDrawer.vue?vue&type=script&lang=js"
export * from "./EditGroupDrawer.vue?vue&type=script&lang=js"
import style0 from "./EditGroupDrawer.vue?vue&type=style&index=0&id=36ff67d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff67d8",
  null
  
)

export default component.exports